import { memo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { Box, Fade, Stack, Typography } from '@rossum/ui/material';
import { AnimatedDots } from './AnimatedDots';

type AgentActivityLabelProps = {
  label: string;
};

const AgentActivityLabelComponent = ({ label }: AgentActivityLabelProps) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    data-cy="chat-agent-activity"
    sx={{ minWidth: 0 }}
  >
    <AnimatedDots sx={{ ml: 0, flexShrink: 0 }} />
    {/* Old and new labels share one grid cell so they cross-fade in place. */}
    <Box sx={{ display: 'grid', minWidth: 0 }}>
      <TransitionGroup component={null}>
        <Fade key={label} timeout={300}>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ gridArea: '1 / 1' }}
          >
            {label}
          </Typography>
        </Fade>
      </TransitionGroup>
    </Box>
  </Stack>
);

export const AgentActivityLabel = memo(AgentActivityLabelComponent);
